
    import { injectTypes } from '@/Types/InjectTypes';

    export default {
        provide() {
            return {
                [injectTypes.adyenPaymentContext]: {
                    clientKey: this.clientKey,
                    gatewayMerchantId: this.gatewayMerchantId,
                    merchantName: this.merchantName,
                    useLiveMode: this.useLiveMode,
                    enabledPaymentMethods: this.enabledPaymentMethods,
                },
            };
        },
        props: {
            clientKey: {
                type: String,
                required: true,
            },
            gatewayMerchantId: {
                type: String,
                required: true,
            },
            useLiveMode: {
                type: Boolean,
                required: true,
            },
            merchantName: {
                type: String,
                required: true,
            },
            enabledPaymentMethods: {
                type: Array,
                required: false,
                default: () => [],
            },
        },
        render() {
            return this.$slots.default[0];
        },
    };
